import { Button, Spinner } from "@heroui/react";
import { useServerFn } from "@tanstack/react-start";

import { AltaviaLogoBigPNG } from "@onesolution/assets";
import { LanguageSelect, Logo, ThemeSwitcher } from "@onesolution/components";
import { useLanguage } from "@onesolution/hooks";
import { login } from "@onesolution/serverFn";
import { checkSso } from "@onesolution/serverFn/auth/checksso";
import { useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export default function LoginPage() {
	const goToLoginKeycloak = useServerFn(login);
	const checksso = useServerFn(checkSso);
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const { t } = useLanguage();

	// kryss sso do not redirect correctly, so we do it mannually
	useEffect(() => {
		const email = localStorage.getItem("SSO-LAST-TRY");
		if (!email) return;
		setIsLoading(true);

		localStorage.removeItem("SSO-LAST-TRY");
		checksso({ data: { email } }).then((alreadyConnected) => {
			if (alreadyConnected) {
				goToLoginKeycloak().then((r) => {
					navigate(r);
				});
			} else {
				setIsLoading(false);
			}
		});
	}, [checksso, goToLoginKeycloak, navigate]);
	return (
		<div>
			<div className="grid grid-cols-1 md:grid-cols-2 h-screen py-6">
				<div className="flex flex-col justify-between items-center py-4 px-6 md:pl-10">
					<div className="self-start">
						<Logo />
					</div>

					{isLoading ? (
						<Spinner size="lg" />
					) : (
						<div className="flex flex-col gap-5 w-full md:w-[420px]">
							<div className="flex flex-col gap-1">
								<h2 className="text-xl font-semibold">{t("login.welcome")},</h2>
								<h4 className="text-sm text-content4-foreground">
									{t("login.continue")}
								</h4>
							</div>

							<Button
								color="primary"
								onPress={async () => {
									const url = await goToLoginKeycloak();
									navigate(url);
								}}
								size="lg"
								className="w-full"
							>
								{t("login.login")}
							</Button>
							<Button
								color="primary"
								onPress={async () => {
									navigate({ href: "/login-sso" });
								}}
								size="lg"
								className="w-full"
							>
								{t("login.login-sso")}
							</Button>
						</div>
					)}

					<div className="flex items-center w-full gap-1">
						<LanguageSelect collapsed />
						<ThemeSwitcher />
					</div>
				</div>

				<img
					aria-label="Altavia logo velvet"
					className="hidden md:block size-full overflow-hidden rounded-s-3xl shadow-2xl object-cover mix-blend-luminosity"
					src={AltaviaLogoBigPNG}
				/>
			</div>
		</div>
	);
}
